/* eslint-disable no-param-reassign */
import { register, load } from '@shopify/theme-sections';
Avatar.theme = Avatar.theme || {};

Avatar.theme.CartRecommendations = function CartRecommendations() {
  function init(container) {
    var _container$dataset = container.dataset,
        baseUrl = _container$dataset.baseUrl,
        productId = _container$dataset.productId,
        limit = _container$dataset.limit,
        sectionType = _container$dataset.sectionType;
    var request = "\n      ".concat(baseUrl, "?section_id=").concat(sectionType, "&product_id=").concat(productId, "&limit=").concat(limit, "\n    ");
    if (productId === '') return;
    fetch(request).then(function (res) {
      return res.text();
    }).then(function (productHtml) {
      if (productHtml.trim() === '') return;
      container.innerHTML = productHtml;
      container.innerHTML = container.firstElementChild.innerHTML;
    });
  }

  return {
    init: init
  };
}();

register('cart-recommendations', {
  onLoad: function onLoad() {
    Avatar.theme.CartRecommendations.init(this.container);
  }
});
load('cart-recommendations');